import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import './Contact.scss';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // TODO: Implement form submission logic
  };

  return (
    <div className="contact-page">
      <PageHeader 
        title="Contactez-Nous" 
        subtitle="Nous sommes à votre écoute"
        breadcrumb={['Accueil', 'Contact']}
        image="/assets/IMG/Header_Contact.png"
        hideText={true}
      />

      <div className="contact-container">
        <div className="contact-grid">
          <div className="contact-info">
            <h2>Informations de Contact</h2>
            <p className="intro-text">
              N'hésitez pas à nous contacter pour toute question concernant nos programmes, 
              partenariats ou opportunités de collaboration.
            </p>

            <div className="info-items">
              <div className="info-item">
                <div className="info-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M3 5 L21 5 L21 19 L3 19 Z"/>
                    <path d="M3 5 L12 12 L21 5"/>
                  </svg>
                </div>
                <div className="info-content">
                  <h3>Email</h3>
                  <p>info@fondationbetalented.org</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 8 L7 6 L10 8 L8 13 L16 13 L14 8 L17 6 L19 8"/>
                  </svg>
                </div>
                <div className="info-content">
                  <h3>Téléphone</h3>
                  <p>+225 07 58 12 92 77</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="10" r="4"/>
                    <path d="M12 20 C7 20 3 16 3 10 C3 6 7 2 12 2 C17 2 21 6 21 10 C21 16 17 20 12 20 Z"/>
                  </svg>
                </div>
                <div className="info-content">
                  <h3>Adresse</h3>
                  <p>Cocody, Abidjan, Côte d'Ivoire</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M12 4 L12 12 L18 12"/>
                  </svg>
                </div>
                <div className="info-content">
                  <h3>Horaires</h3>
                  <p>Lundi - Vendredi : 8h00 - 17h00</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <h2>Envoyez-nous un Message</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Nom complet *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Votre nom complet"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="votre.email@exemple.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Téléphone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+225 XX XX XX XX XX"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Sujet *</label>
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                >
                  <option value="">Sélectionnez un sujet</option>
                  <option value="programme">Information sur les programmes</option>
                  <option value="inscription">Inscription</option>
                  <option value="partenariat">Partenariat</option>
                  <option value="autre">Autre</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  placeholder="Votre message..."
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                Envoyer le message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
